import React, { useEffect, useState } from 'react';
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';
import { RxDot, RxDotFilled } from 'react-icons/rx';
import styled from 'styled-components';
import Img1 from '../../bmw/bmw1.jpg';
import Img2 from '../../bmw/bmw2.jpg';
import Img3 from '../../bmw/bmw3.jpg';
import Img4 from '../../bmw/bmw4.jpg';
import Img5 from '../../bmw/bmw5.jpg';
import Img6 from '../../bmw/bmw6.jpg';

import Img7 from '../../bmw/bmw7.jpg';
import Img8 from '../../bmw/bmw8.jpg';
import Img9 from '../../bmw/bmw9.jpg';
import Img10 from '../../bmw/bmw10.jpg';
import Img11 from '../../bmw/bmw11.jpg';
import Img12 from '../../bmw/bmw12.jpg';
import Img13 from '../../bmw/bmw13.jpg';
import Img14 from '../../bmw/bmw14.jpg';
import Img15 from '../../bmw/bmw15.jpg';
import Img16 from '../../bmw/bmw16.jpg';
import Img17 from '../../bmw/bmw17.jpg';
import Img18 from '../../bmw/bmw18.jpg';
import Img19 from '../../bmw/bmw19.jpg';
import Img20 from '../../bmw/bmw20.jpg';

import { Button } from '../Button/ButtonElements';
import Contact from '../Contact/Contact';
import Dropdown from '../Navbar/Dropdown';
import MenuList from '../Navbar/Menu';
import Navbar from '../Navbar/Navbar';
import './Slider.css';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi';

const Background = styled.div`
  width: 100%;
  overflow-x: hidden;
  //padding-top: 50px;
  @media screen and (max-width: 500px) {
    //padding-top: 50px;
  }
`;
const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;

  @media screen and (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 600px) {
    margin-top: 115px;
  }
`;
const Container = styled.div`
  margin-top: 50px;
`;
const DetailsText = styled.div`
  padding: 10%;
  // padding-left: 40%;
  // padding-right: 40%;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 1rem;
  font-family: 'Poppins';
  font-weight: 300;
`;
const DetailsPrice = styled.h1`
  text-align: center;
  font-family: 'Poppins';
  font-weight: 300;
`;
const DetailsMiles = styled.h2`
  text-align: center;
  font-family: 'Poppins';
  font-weight: 300;
  font-size: 1.2rem;
`;
const DetailsHeader = styled.h1`
  font-size: 2.5rem;
  font-family: 'Poppins';
  font-weight: 400;
`;
const DetailsContainer = styled.div`
  margin-top: 50px;
  @media screen and (max-width: 768px) {
    margin-top: -75px;
  }
  @media screen and (max-width: 550px) {
    margin-left: 15px;
  }
`;
const DetailsWrapper = styled.div``;
const Socials = styled.div``;
const ValueCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  // border-radius: 10px;
  max-height: 340px;
  margin-right: 15px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
`;
const ValueCard2 = styled.div`
  background: rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  //margin-left: -5px;
  margin-right: 15px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  margin-top: 0px;
  @media screen and (max-width: 500px) {
    margin-top: 50px;
  }
  @media screen and (max-width: 768px) {
    margin-top: 50px;
  }
`;
const SubTitle = styled.div`
  font-size: 1.2rem;
  text-align: center;
`;
const Number = styled.div`
  background: rgba(0, 0, 0, 0.2);
  text-decoration: none;
  outline: none;
  border: 1px solid rgb(178, 12, 78);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;

  padding: 20px;
  font-size: 1.2rem;

  &:hover {
    transition: all 0.2 ease-in-out;
    background: #fff;
    border: 1px solid rgb(178, 12, 78);
  }
`;
const ContactWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-right: 15px;
`;
const Social = styled.div`
  font-size: 1.8rem;
  text-align: center;
  margin-top: 50px;
`;
const Icons = styled.div`
  text-align: center;
`;
const Paragraph = styled.div`
  font-weight: bold;
  text-align: center;
  padding: 24px;
  margin-top: 25px;
`;
const SliderWrapper = styled.div`
  margin-top: 0%;
  // margin-left: -50px;
`;
const ContactHeader = styled.h1`
  margin-top: 30px;
  font-size: 1.6rem;
`;
const BtnWrap = styled.div`
  max-width: 300px;
  margin-top: 25px;
  margin-bottom: 50px;
`;
const Icon = styled.span`
  &:hover {
    transform: scale(1.05);
  }
`;
const BtnWrapWrap = styled.div`
  display: flex;
  justify-content: center;
`;
const TextWrap = styled.div`
  padding-left: 75px;
  padding-right: 75px;
  @media screen and (max-width: 500px) {
    padding: 0;
  }
`;
const Bmw = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const [currentSlide, setCurrentSlide] = useState(0);
  const data = [
    Img1,
    Img2,
    Img3,
    Img4,
    Img5,
    Img6,
    Img7,
    Img8,
    Img9,
    Img10,
    Img11,
    Img12,
    Img13,
    Img14,
    Img15,
    Img16,
    Img17,
    Img18,
    Img19,
    Img20,
  ];
  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? 19 : (prev) => prev - 1);
  };
  const nextSlide = () => {
    setCurrentSlide(currentSlide === 19 ? 0 : (prev) => prev + 1);
  };

  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };
  console.log(currentIndex);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1200); // Adjust the breakpoint as needed
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial call

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <Background>
      <Navbar toggle={toggle} />
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <MenuList />
      <Wrapper>
        <Container>
          <SliderWrapper>
            <div className="overflow-hidden flex justify-center align-middle contM">
              <div className=" w-[100vw] h-[450px] relative  boxM">
                <div
                  style={{
                    transform: `translateX(-${
                      currentSlide * (isSmallScreen ? 100 : 50)
                    }vw)`,
                  }}
                  className="w-[2300vw] h-full flex transition-transform duration-1000 img-boxM"
                >
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[0]}
                    alt=""
                    loading="priority"
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[1]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[2]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[3]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[4]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[5]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[6]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[7]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[8]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[9]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[10]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[11]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[12]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[13]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[14]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[15]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[16]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[17]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[18]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[19]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[20]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[21]}
                    alt=""
                  />
                  <img
                    className="w-[100vw] h-[250px] object-cover imgM"
                    src={data[22]}
                    alt=""
                  />
                </div>
                <div className="w-full h-full flex align-middle">
                  <div className="absolute w-fit left-[1%] mx-auto flex gap-8 top-[45%] arrowsM">
                    <div
                      onClick={prevSlide}
                      className="w-14 text-white h-14 border-[1px] border-white flex items-center justify-center hover:cursor-pointer hover:bg-black hover:text-white activ:bg-gray-900 duration-300 arrow-left absolute left-0"
                    >
                      <HiArrowLeft />
                    </div>
                  </div>
                  <div className="absolute w-fit right-[1%] mx-auto flex gap-8 top-[45%] arrowsM">
                    <div
                      onClick={nextSlide}
                      className="w-14 h-14 text-white border-[1px] border-white flex items-center justify-center hover:cursor-pointer  hover:bg-black hover:text-white activ:bg-gray-900 duration-300 arrow-right"
                    >
                      <HiArrowRight />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SliderWrapper>
        </Container>
        <DetailsContainer>
          <DetailsWrapper>
            <ValueCard2>
              <DetailsHeader>BMW 318 Automatic</DetailsHeader>
              <SubTitle>
                Sport 1.5 petrol, Automatic, Saloon, 2016 / 66 reg.
              </SubTitle>
            </ValueCard2>
            <ValueCard>
              <DetailsPrice>
                Only <strong>£11,490</strong>
              </DetailsPrice>
              <DetailsMiles>58,920 Miles</DetailsMiles>
            </ValueCard>
            <ContactWrapper>
              <Number>
                <i class="fa-solid fa-phone"></i>
                <a href="tel: 0115 9313 131" className="num">
                  {' '}
                  0115 9313 131
                </a>
              </Number>
              <Number>
                <i class="fa-solid fa-phone"></i>
                <a href="tel: 07947 916 916" className="num">
                  {' '}
                  07947 916 916
                </a>
              </Number>
            </ContactWrapper>
            <Social>View car on our socials:</Social>
            <Icons>
              <Icon>
                <a
                  href="https://www.facebook.com/MotorsForYouLtd/"
                  class="fa fa-facebook"
                ></a>
              </Icon>
              <Icon>
                <a
                  href="https://www.instagram.com/p/C191YvGiOvj/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=="
                  class="fa fa-instagram"
                ></a>
              </Icon>
            </Icons>
          </DetailsWrapper>
          <Socials></Socials>
        </DetailsContainer>
      </Wrapper>
      <Paragraph>Details you'll want to know:</Paragraph>
      <TextWrap>
        <DetailsText>
          We are pleased to offer to market this stunning looking BMW 3 series
          Sport. Great specification is complimented with a really smooth ride
          from the gearbox and suspension.
        </DetailsText>
        <DetailsText>
          Specification includes 17in Alloy Wheels, 3.5mm Auxiliary Input Point
          in Centre Console for Auxiliary Playing Devices, 6.5in Colour Display
          Screen, Air Conditioning - Automatic with Two-Zone Control, Air
          Conditioning and Radio Control Panel with Chrome Highlight, Airbags,
          Alarm System - Thatcham 1 with Remote Control and Engine Immobiliser,
          Ambient Lighting - Switchable BMW Classic Orange - Cold White - LED,
          Automatically Dimming Rear View Mirror, BMW ConnectedDrive Online
          Services, BMW Navigation System, Battery Safety Cut Off, Bluetooth
          Hands Free with USB Audio Interface, Bottle Holders Integrated into
          Door Trim Storage Compartments, Bumper - Rear with Black High Gloss
          Finisher, Bumper System Front and Rear - Replaceable Deformation
          Elements for Impacts Up to 9mph, Central Locking Switch - Doors - Fuel
          Filler Cap - Luggage Compartment, Crash Sensor - Activating Central
          Locking Release - Hazard Warning Lights - Battery Safety Cut Off -
          Interior Lighting, Cruise Control with Brake Function, DAB Digital
          Radio, DSC - Dynamic Stability Control Plus, Door Sill Finishers -
          Neutral BMW Designation - Front, Drive Performance Control - ECO PRO -
          Comfort - Sport and Sport Plus, Dynamic Brake Lights, Enhanced
          Bluetooth Telephone Preparation with USB Audio Interface and Voice
          Control, Extended Lighting, Exterior B Pillar - High Gloss Black,
          Exterior Mirrors - Heated - Electrically Adjustable, Exterior Parts in
          Body Colour, Exterior Trim - Matt Black, First Aid Kit and Warning
          Triangle, Foglights - Halogen Front and LED Rear, Front Air Inlet with
          High-Gloss Black Finisher, Glove Box Opener with Chrome Spider,
          Halogen Headlights, Handbrake and Gear Knob - Leather, Heat Protection
          Glazing with Green Tint, Indicator Lenses - Clear, Instrument Cluster,
          Interior Lighting, Interior Trim - High-Gloss Black with Coral Red
          Matt Finisher, Interior Trim - High-Gloss Black with Pearl Chrome
          Finisher, Lashing Eyes in Luggage Compartment x4, Media Package - BMW
          Business, Model Designation, Non Smokers Package, PDC - Park Distance
          Control - Rear, Personal Profile, Real Time Traffic Information, Rear
          Seat Headrests - Three, Rear Suspension - Five-Link, Seat Belt
          Security Check for Driver, Shark Fin, Side Air Inlets - Highlighter in
          Black-Aluminium, Side Armrests - Front and Rear Integrated into Door
          Trim, Side Impact Protection, Sport Instrument Cluster with Red
          Highlight and Chrono Scale, Sport Seats - Front, Start-Stop Button
          with Comfort Go Keyless Engine Start and Auto Start-Stop Deactivation
          Button, Sun Visors with Illuminated Vanity Mirrors and Ticket Pocket,
          Suspension - Front Aluminium, TPMS - Tyre Pressure Monitoring System,
          Three-Point Seat Belts - All Seats, Trim Designation Deletion, Twin
          Horns, Tyres - Reduced Rolling Resistance, Welcome Light, Windscreen
          Wipers - Two-Speed with Adjustable Intervals etc.
        </DetailsText>
        <DetailsText>
          In great condition and is offered with 6 months Nationwide warranty.
          Two new tyres have been fitted as part of the pre sale preparation and
          the MOT is valid until february 2025 with NO advisories ! H.P.I clear
          with full report, owners book pack and spare key. Part exchange and
          finance facilities available. Check out our reviews on Trustpilot,
          Facebook and Google.
        </DetailsText>
        <DetailsText>
          We are open 7 days a week from 8a.m until 8p.m. Please call to arrange
          a viewing and test drive by appointment. We look forward to hearing
          from you !
        </DetailsText>
        <DetailsText></DetailsText>
      </TextWrap>
      <ContactHeader>Contact us regarding this listing:</ContactHeader>
      <BtnWrapWrap>
        <BtnWrap>
          <Button href="/contact">Contact Us</Button>
        </BtnWrap>
      </BtnWrapWrap>
    </Background>
  );
};

export default Bmw;
